import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/react';
import App from './App';
import { clerkPublishableKey, runtimeConfigError } from './runtime-config';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

// `pnpm dev:demo`: answer API calls with dummy data. Never part of a real build.
if (import.meta.env.VITE_DEMO === 'true') {
  const { installDemoApi } = await import('./demo/demo-api');
  installDemoApi();
}

if (runtimeConfigError) {
  const message = document.createElement('p');
  message.setAttribute('role', 'alert');
  message.textContent = `Admin configuration error: ${runtimeConfigError}`;
  root.replaceChildren(message);
} else {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ClerkProvider
        publishableKey={clerkPublishableKey}
        signInUrl="/login"
        signInFallbackRedirectUrl="/dashboard"
        signUpFallbackRedirectUrl="/dashboard"
      >
        <App />
      </ClerkProvider>
    </React.StrictMode>,
  );
}
